import { useAuth0 } from "@auth0/auth0-react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import Auth0ProviderWithHistory from "components/auth0-provider-with-history";
import React from "react";
import ReactDOM from "react-dom/client";
import "react-datepicker/dist/react-datepicker.css";
import { BrowserRouter as Router } from "react-router-dom";
import AuthApp from "./auth-app";
import UnAuthApp from "./unauth-app";
import "./index.css";

const AuthGate = () => {
    const { isLoading, user } = useAuth0();

    if (isLoading) {
        return (
            <div className="h-screen bg-gray-800 grid place-items-center text-white">
                <div className="flex flex-col items-center px-8 max-w-xs md:max-w-lg text-center">
                    <svg
                        className="animate-spin -ml-1 mr-3 h-9 w-9"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                    >
                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                        <path
                            className="opacity-75"
                            fill="currentColor"
                            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                        />
                    </svg>
                    <h2 className="text-xl font-semibold mt-3">Loading...</h2>
                    <p className="mt-1">This may take a few seconds, please don't close this page.</p>
                </div>
            </div>
        );
    }

    return user ? <AuthApp /> : <UnAuthApp />;
};

const queryClient = new QueryClient();

const App = () => (
    <QueryClientProvider client={queryClient}>
        <Router>
            <Auth0ProviderWithHistory>
                <AuthGate />
            </Auth0ProviderWithHistory>
        </Router>
        {import.meta.env.DEV && <ReactQueryDevtools initialIsOpen={false} />}
    </QueryClientProvider>
);

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

root.render(<App />);
